import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { VideoPlayer } from "./Video";
import { isImage, isVideo } from "../utils/mimetypes";

export const FilePreview = ({
  isOpen,
  onClose,
  file,
}: {
  isOpen: boolean;
  onClose: () => void;
  file?: {
    [key: string]: any;
    fileType: string;
    fileId: string;
  };
}) => {
  if (!isOpen) return null;
  return (
    <div
      role='button'
      tabIndex={-1}
      className='tw-fixed tw-inset-0 tw-z-[1001] tw-flex tw-items-center tw-justify-center tw-bg-black tw-bg-opacity-90'
      onClick={onClose}
    >
      <div className='tw-relative tw-w-fit tw-min-w-[20rem] tw-max-w-[80%]'>
        <button
          className='tw-fixed tw-right-0 tw-top-0 tw-m-4 tw-cursor-pointer tw-border-none tw-bg-transparent tw-text-white'
          onClick={onClose}
        >
          <FontAwesomeIcon icon={faXmark} className='tw-h-6 tw-w-6' />
        </button>
        {file?.url ? (
          <div role='button' tabIndex={0} onClick={(e) => e.stopPropagation()}>
            {isImage(file.fileType) && (
              <img
                src={file?.url}
                alt='attachment'
                className='tw-h-auto tw-max-h-screen tw-w-full tw-rounded-3xl tw-p-4'
              />
            )}
            {isVideo(file.fileType) && <VideoPlayer uuid={file.fileId} />}
            {!isImage(file.fileType) && !isVideo(file.fileType) && (
              <div className='tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-3xl tw-bg-[#252525] tw-px-24 tw-py-8'>
                <i className='huge file outline icon tw-text-white-mid' />
                <p className='tw-mb-6 tw-mt-4 tw-text-lg tw-text-white-mid'>No preview available</p>
                <a href={file.url} download className='ui primary button' onClick={(e) => e.stopPropagation()}>
                  Download File
                </a>
              </div>
            )}
          </div>
        ) : (
          <div className='ui placeholder segment tw-flex tw-h-80 tw-items-center tw-justify-center'>
            <div className='ui active centered inline loader'></div>
          </div>
        )}
      </div>
    </div>
  );
};
